var BASWebServices;
(function (BASWebServices) {
    var WebMAUSState = (function () {
        function WebMAUSState($stateProvider, $urlRouterProvider, $locationProvider) {
            $urlRouterProvider.otherwise('/interface');
            console.log('Creating routes...');
            $stateProvider
                .state('interface', {
                url: '/interface',
                templateUrl: 'views/partials/homepage.html',
                controller: ['$state',
                    '$location',
                    'ngDialog',
                    function ($state, $location, ngDialog) {
                        if ($location.host().lastIndexOf("clarin") == -1
                            && $location.host().lastIndexOf("127.0.0.1") == -1
                            && $location.host().lastIndexOf("localhost") == -1
                            && $location.absUrl().lastIndexOf("ToolTest") == -1) {
                            ngDialog.open({
                                template: 'views/partials/dialogs/wrongURL.html',
                                className: 'ngdialog-theme-default',
                                closeByEscape: true
                            });
                        }
                    }],
                onEnter: function () { console.log("Aha"); }
            })
                .state('interface.WebMAUSBasic', {
                url: '/WebMAUSBasic',
                templateUrl: 'views/partials/WebMAUSBasic.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        var serviceName = 'runMAUSBasic';
                        var wsDataInternal = wsData;
                        var optionsForServicePromise = cmdiOptions.getNecessaryParameters(serviceName);
                        optionsForServicePromise.then(function (data) {
                            wsDataInternal.clear();
                            wsDataInternal.addNecessaryKeys(data);
                            wsDataInternal.setServiceName(serviceName);
                        });
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'WebMAUSBasic', serviceName);
                    }]
            })
                .state('interface.WebMAUSGeneral', {
                url: '/WebMAUSGeneral',
                templateUrl: 'views/partials/WebMAUSGeneral.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'WebMAUSGeneral', 'runMAUS');
                    }]
            })
                .state('interface.Grapheme2Phoneme', {
                url: '/Grapheme2Phoneme',
                templateUrl: 'views/partials/Grapheme2Phoneme.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'Graphem2Phoneme', 'runG2P');
                    }]
            })
                .state('interface.Coala', {
                url: '/Coala',
                templateUrl: 'views/partials/Coala.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'Coala', 'runCOALA');
                    }]
            })
                .state('interface.ChunkPreparation', {
                url: '/ChunkPreparation',
                templateUrl: 'views/partials/ChunkPreparation.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'ChunkPreparation', 'runChunkPreparation');
                    }]
            })
                .state('interface.WebMINNI', {
                url: '/WebMINNI',
                templateUrl: 'views/partials/WebMINNI.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'WebMINNI', 'runMINNI');
                    }]
            })
                .state('interface.Pho2Syl', {
                url: '/Pho2Syl',
                templateUrl: 'views/partials/Pho2Syl.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'Pho2Syl', 'runPho2Syl');
                    }]
            })
                .state('interface.TextAlign', {
                url: '/TextAlign',
                templateUrl: 'views/partials/TextAlign.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'TextAlign', 'runTextAlign');
                    }]
            })
                .state('interface.Chunker', {
                url: '/Chunker',
                templateUrl: 'views/partials/Chunker.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'Chunker', 'runChunker');
                    }]
            })
                .state('interface.Pipeline', {
                url: '/Pipeline',
                templateUrl: 'views/partials/Pipeline.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'Pipeline', 'runPipeline');
                    }]
            })
                .state('interface.PipelineWithASR', {
                url: '/PipelineWithASR',
                templateUrl: 'views/partials/PipelineWithASR.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'PipelineWithASR', 'runPipelineWithASR');
                        var cookies = $rootScope.cookies;
                        var currTime = new Date().getTime();
                        setTimeout(function () {
                            if (cookies.get('asr_reload_happened') == null) {
                                cookies.put('asr_reload_happened', currTime);
                                window.location.reload();
                            }
                            else {
                                var oldTime = parseInt(cookies.get('asr_reload_happened', 10));
                                if ((currTime - oldTime) > 15000) {
                                    cookies.put('asr_reload_happened', currTime);
                                    window.location.reload();
                                }
                            }
                        }, 200);
                    }]
            })
                .state('interface.ASR', {
                url: '/ASR',
                templateUrl: 'views/partials/ASR.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'ASR', 'runASR');
                        var cookies = $rootScope.cookies;
                        var currTime = new Date().getTime();
                        setTimeout(function () {
                            if (cookies.get('asr_reload_happened') == null) {
                                cookies.put('asr_reload_happened', currTime);
                                window.location.reload();
                            }
                            else {
                                var oldTime = parseInt(cookies.get('asr_reload_happened', 10));
                                if ((currTime - oldTime) > 15000) {
                                    cookies.put('asr_reload_happened', currTime);
                                    window.location.reload();
                                }
                            }
                        }, 200);
                    }]
            })
                .state('interface.ASRLogin', {
                url: '/ASRLogin',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        window.location.replace('/asr.html');
                    }]
            })
                .state('interface.EMUMagic', {
                url: '/EMUMagic',
                templateUrl: 'views/partials/EMUMagic.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'EMUMagic', 'runEMUMagic');
                        var cookies = $rootScope.cookies;
                        var currTime = new Date().getTime();
                        setTimeout(function () {
                            if (cookies.get('asr_reload_happened') == null) {
                                cookies.put('asr_reload_happened', currTime);
                                window.location.reload();
                            }
                            else {
                                var oldTime = parseInt(cookies.get('asr_reload_happened', 10));
                                if ((currTime - oldTime) > 15000) {
                                    cookies.put('asr_reload_happened', currTime);
                                    window.location.reload();
                                }
                            }
                        }, 200);
                    }]
            })
                .state('interface.FormantAnalysis', {
                url: '/FormantAnalysis',
                templateUrl: 'views/partials/FormantAnalysis.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'FormantAnalysis', 'runFormantAnalysis');
                    }]
            })
                .state('interface.Subtitle', {
                url: '/Subtitle',
                templateUrl: 'views/partials/Subtitle.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'Subtitle', 'runSubtitle');
                    }]
            })
                .state('interface.VoiceActivityDetection', {
                url: '/VoiceActivityDetection',
                templateUrl: 'views/partials/VoiceActivityDetection.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'VoiceActivityDetection', 'runVoiceActivityDetection');
                    }]
            })
                .state('interface.Anonymizer', {
                url: '/Anonymizer',
                templateUrl: 'views/partials/Anonymizer.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'Anonymizer', 'runAnonymizer');
                    }]
            })
                .state('interface.SpeakDiar', {
                url: '/SpeakDiar',
                templateUrl: 'views/partials/SpeakDiar.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'SpeakDiar', 'runSpeakDiar');
                    }]
            })
                .state('interface.AnnotConv', {
                url: '/AnnotConv',
                templateUrl: 'views/partials/AnnotConv.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'AnnotConv', 'runAnnotConv');
                    }]
            })
                .state('interface.AudioEnhance', {
                url: '/AudioEnhance',
                templateUrl: 'views/partials/AudioEnhance.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'AudioEnhance', 'runAudioEnhance');
                    }]
            })
                .state('interface.ChannelSeparator', {
                url: '/ChannelSeparator',
                templateUrl: 'views/partials/ChannelSeparator.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'ChannelSeparator', 'runChannelSeparator');
                    }]
            })
                .state('interface.TextEnhance', {
                url: '/TextEnhance',
                templateUrl: 'views/partials/TextEnhance.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'TextEnhance', 'runTextEnhance');
                    }]
            })
                .state('interface.clarinIFrame', {
                url: '/clarinIFrame',
                templateUrl: 'views/partials/clarinIFrame.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    'CMDIOptions',
                    'WebServiceData',
                    function ($scope, $rootScope, $state, $location, cmdiOptions, wsData) {
                        var serviceName = 'runMAUSBasic';
                        var wsDataInternal = wsData;
                        var optionsForServicePromise = cmdiOptions.getNecessaryParameters(serviceName);
                        optionsForServicePromise.then(function (data) {
                            wsDataInternal.clear();
                            wsDataInternal.addNecessaryKeys(data);
                            wsDataInternal.setServiceName(serviceName);
                        });
                        WebMAUSState.settingStates($scope, $rootScope, $state, $location, cmdiOptions, wsData, 'WebMAUSBasic', serviceName);
                    }]
            })
                .state('tutorial', {
                url: '/help/tutorial',
                templateUrl: 'views/partials/tutorial.html'
            })
                .state('contact', {
                url: '/contact',
                templateUrl: 'views/partials/contact.html'
            })
                .state('help', {
                url: '/help',
                templateUrl: 'views/partials/help.html',
                resolve: {
                    touAcaServiceResolve: ["TermsOfUsageService", function (TermsOfUsageService) {
                            return TermsOfUsageService.getTOUContentAcademic();
                        }],
                    touComServiceResolve: ["TermsOfUsageService", function (TermsOfUsageService) {
                            return TermsOfUsageService.getTOUContentCommercial();
                        }]
                },
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    '$anchorScroll',
                    '$timeout',
                    function ($scope, $rootScope, $state, $location, $anchorScroll, $timeout, touAcaServiceResolve, touComServiceResolve) {
                        var targetID = $scope.$$hash;
                        var sc = new BASWebServices.ScrollController($scope, $rootScope, $state, $location, $anchorScroll, $timeout, targetID);
                    }]
            })
                .state('help.tou', {
                url: '/termsOfUsage',
                templateUrl: 'views/partials/help.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    '$anchorScroll',
                    '$timeout',
                    function ($scope, $rootScope, $state, $location, $anchorScroll, $timeout) {
                        var targetID = "termsofusage";
                        var sc = new BASWebServices.ScrollController($scope, $rootScope, $state, $location, $anchorScroll, $timeout, targetID);
                    }]
            }).state('help.versions', {
                url: '/toolVersions',
                templateUrl: 'views/partials/help.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    '$anchorScroll',
                    '$timeout',
                    function ($scope, $rootScope, $state, $location, $anchorScroll, $timeout) {
                        var targetID = "tool_versions";
                        var sc = new BASWebServices.ScrollController($scope, $rootScope, $state, $location, $anchorScroll, $timeout, targetID);
                    }]
            })
                .state('help.contact', {
                url: '/help_contact',
                templateUrl: 'views/partials/help.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    '$anchorScroll',
                    '$timeout',
                    function ($scope, $rootScope, $state, $location, $anchorScroll, $timeout) {
                        var targetID = "help_contact";
                        var sc = new BASWebServices.ScrollController($scope, $rootScope, $state, $location, $anchorScroll, $timeout, targetID);
                    }]
            })
                .state('help.videos', {
                url: '/help_videos',
                templateUrl: 'views/partials/help.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    '$anchorScroll',
                    '$timeout',
                    function ($scope, $rootScope, $state, $location, $anchorScroll, $timeout) {
                        var targetID = "help_videos";
                        var sc = new BASWebServices.ScrollController($scope, $rootScope, $state, $location, $anchorScroll, $timeout, targetID);
                    }]
            })
                .state('help.faq', {
                url: '/help_faq',
                templateUrl: 'views/partials/help.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    '$anchorScroll',
                    '$timeout',
                    function ($scope, $rootScope, $state, $location, $anchorScroll, $timeout) {
                        var targetID = "help_faq";
                        var sc = new BASWebServices.ScrollController($scope, $rootScope, $state, $location, $anchorScroll, $timeout, targetID);
                    }]
            })
                .state('help.usecases', {
                url: '/help_usecases',
                templateUrl: 'views/partials/help.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    '$anchorScroll',
                    '$timeout',
                    function ($scope, $rootScope, $state, $location, $anchorScroll, $timeout) {
                        var targetID = "help_usecases";
                        var sc = new BASWebServices.ScrollController($scope, $rootScope, $state, $location, $anchorScroll, $timeout, targetID);
                    }]
            })
                .state('help.examples', {
                url: '/help_examples',
                templateUrl: 'views/partials/help.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    '$anchorScroll',
                    '$timeout',
                    function ($scope, $rootScope, $state, $location, $anchorScroll, $timeout) {
                        var targetID = "help_examples";
                        var sc = new BASWebServices.ScrollController($scope, $rootScope, $state, $location, $anchorScroll, $timeout, targetID);
                    }]
            })
                .state('help.developer', {
                url: '/help_developer',
                templateUrl: 'views/partials/help.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    '$anchorScroll',
                    '$timeout',
                    function ($scope, $rootScope, $state, $location, $anchorScroll, $timeout) {
                        var targetID = "help_developer";
                        var sc = new BASWebServices.ScrollController($scope, $rootScope, $state, $location, $anchorScroll, $timeout, targetID);
                    }]
            })
                .state('help.maus', {
                url: '/help_maus',
                templateUrl: 'views/partials/help.html',
                controller: ['$scope',
                    '$rootScope',
                    '$state',
                    '$location',
                    '$anchorScroll',
                    '$timeout',
                    function ($scope, $rootScope, $state, $location, $anchorScroll, $timeout) {
                        var targetID = "help_usecases";
                        var sc = new BASWebServices.ScrollController($scope, $rootScope, $state, $location, $anchorScroll, $timeout, targetID);
                    }]
            })
                .state('publications', {
                url: '/publications',
                templateUrl: 'views/partials/publications.html'
            });
        }
        WebMAUSState.settingStates = function ($scope, $rootScope, $state, $location, cmdiOptions, wsData, webMAUSState, serviceName) {
            var wsDataInternal = wsData;
            var optionsForServicePromise = cmdiOptions.getNecessaryParameters(serviceName);
            optionsForServicePromise.then(function (data) {
                wsDataInternal.clear();
                if (serviceName == "runSpeakDiar" || serviceName == "runPipelineWithASR" || serviceName == "runEMUMagic") {
                    var newData = Array();
                    for (var idx in data) {
                        if (data[idx] == "TEXT") {
                            ;
                        }
                        else {
                            newData.push(data[idx]);
                        }
                    }
                    data = newData;
                }
                wsDataInternal.addNecessaryKeys(data);
                wsDataInternal.setServiceName(serviceName);
            });
        };
        return WebMAUSState;
    }());
    BASWebServices.WebMAUSState = WebMAUSState;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=WebMAUSState.js.map